const Constants: {
  TOKEN: string;
  EXPIRY: number;
} = {
  TOKEN: '',
  EXPIRY: 0,
};

export default Constants;
